import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import classNames from 'classnames';
import queryString from 'query-string';
import isEmpty from 'lodash';

import OutputText from '@ey/canvascoreservices/OutputText';

import OrgChart from './EntityFilters/OrgChart';
import OrgChartRedirect from './EntityFilters/OrgChartRedirect';
import LeftDashboardLoader from '../../Common/Loaders/LeftDashboardLoader';
import StyledSidebar from './StyledSidebar';
import StyledGrid from './StyledGrid';
import StyledCounts from './StyledCounts';
import ClientsCount from './ClientsCount';
import EngagementsCount from './EngagementsCount';
import Members from './Members';

const Sidebar = ({moduleLabel = null}) => {
	const [isOrgChartLoading, setIsOrgChartLoading] = useState(true);

	const userGui = useSelector(({userPreferences}) => userPreferences?.gui);
	const userListPerm = useSelector(({project}) => project?.users);
	const isClassicProject = useSelector(({project}) => !project?.isGroupRiskAssessmentProject);
	const userData = userListPerm?.find(({userId}) => userId === userGui);

	const isProjectOwner = !!userData?.isProjectOwner;

	const getProjectId = () => {
		let query = queryString.parse(location.search.toLowerCase());
		return isEmpty(query?.projectid) ? query.projectid : '';
	};

	const renderModuleName = () => <OutputText h4>{moduleLabel}</OutputText>;

	const renderCounts = () => (
		<StyledCounts>
			<ClientsCount />
			<EngagementsCount />
		</StyledCounts>
	);

	const renderMembers = () => <Members />;

	const renderOrgChart = () => {
		const props = {
			useSession: true,
			projectId: getProjectId(),
			onIsLoaded: () => setIsOrgChartLoading(false)
		};
		return <OrgChart {...props} />;
	};

	const renderOrgChartRedirect = () => {
		const props = {
			projectId: getProjectId()
		};
		return <OrgChartRedirect {...props} />;
	};

	return (
		<StyledSidebar>
			{isOrgChartLoading && <LeftDashboardLoader />}
			<StyledGrid className={classNames('customScrollbar', {['hide-content']: isOrgChartLoading})}>
				{moduleLabel && renderModuleName()}
				{renderCounts()}
				{isClassicProject && renderMembers()}
				{renderOrgChart()}
			</StyledGrid>
			{isProjectOwner && isClassicProject && renderOrgChartRedirect()}
		</StyledSidebar>
	);
};

Sidebar.propTypes = {
	moduleLabel: PropTypes.string
};

export default Sidebar;
